import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';

function getGoodsLink(item): string {
  return item.url;
}
function getAssembleActivity(item, siteCode): Promise<string> {
  return IPSService.adminCreatePTUrl({
    postParams: {
      ptId: item.ptId,
      siteCode,
    },
  }).then((res) => {
    return res.url;
  });
}
function getLiveUrl(item, siteCode): Promise<string> {
  return IPSService.adminCreateLiveUrl({
    postParams: {
      lvId: item.lvId,
      siteCode,
    },
  }).then((res) => {
    return res.url;
  });
}
function getSkillGroupLink(item, siteCode): Promise<string> {
  return IPSService.adminCreateSKUrl({
    postParams: {
      skgId: item.skgId,
      siteCode,
    },
  }).then((res) => {
    return res.url;
  });
}
function getSkillLink(item, siteCode): Promise<string> {
  return IPSService.adminCreateSKUrl({
    postParams: {
      skId: item.skId,
      siteCode,
    },
  }).then((res) => {
    return res.url;
  });
}

function getActivity(item) {
  return item.url;
}
function getUuid(item) {
  return item;
}

@DialogFactory
@Component({
  mixins: [style],
})
export default class GenerateLink extends IPSDialog {
  /**
   * 外部传入
   * @protected
   */

  // 数据
  public item: any = null;
  // 网点列表
  public siteCodeList = [];
  // 备注
  public remarkList: string[] = [];

  public type = 'default';

  top = '25vh';
  readonly = false;
  width = '680px';
  /**
   * 内部变量
   * @protected
   */
  public url = '';
  public link = '';

  public siteCode = '';

  public flag = false;

  async mounted() {
    if (this.type === 'default') {
      throw new Error('请传入链接的类型');
      return;
    }

    if (this.type === 'goods') {
      this.url = getGoodsLink(this.item);
    }
    if (this.type === 'skillGroup') {
      this.siteCodeList = this.item.siteCodes || [];
      this.url = (await getSkillGroupLink(this.item, this.siteCodeList[0] || '')) || '';
    }
    if (this.type === 'assembleActivity') {
      this.siteCodeList = (this.item.siteList || []).map(i => i.siteCode);
      this.url = (await getAssembleActivity(this.item, this.siteCodeList[0] || '')) || '';
    }
    if (this.type === 'live') {
      this.siteCodeList = this.item.siteList;
      this.url = (await getLiveUrl(this.item, this.siteCodeList[0] || '')) || '';
    }
    if (this.type === 'skill') {
      this.siteCodeList = (this.item.siteList || []).map(i => i.siteCode);
      this.url = (await getSkillLink(this.item, this.siteCodeList[0] || '')) || '';
    }
    if (this.type === 'activity') {
      this.url = (await getActivity(this.item)) || '';
    }
    if (this.type === 'tiny') {
      this.url = getUuid(this.item.wxAppId);
      this.link = getUuid(this.item.url);
      this.flag = true;
    }
  }

  onCopyUrl() {
    Functions.clickCopy(this.url, '链接拷贝成功');
  }

  onCopyUrlT() {
    Functions.clickCopy(this.link, '链接拷贝成功');
  }

  createLink() {
    if (!this.siteCode) {
      this.$message.error('请输入网点编号！');
      return;
    }
    if (this.type === 'skillGroup') {
      getSkillGroupLink(this.item, this.siteCode).then((res) => {
        this.url = res || '';
      });
    }
    if (this.type === 'skill') {
      getSkillLink(this.item, this.siteCode).then((res) => {
        this.url = res || '';
      });
    }
    if (this.type === 'live') {
      getLiveUrl(this.item, this.siteCode).then((res) => {
        this.url = res || '';
      });
    }
    if (this.type === 'assembleActivity') {
      getAssembleActivity(this.item, this.siteCode).then((res) => {
        this.url = res || '';
      });
    }
  }

  renderContent(h): JSX.Element {
    return this.flag ? (
      <div>
        <div class="pop-container">
          <span class="r-mr-10">小程序APPID</span>
          <el-input class="wid-234" v-model={this.url} disabled placeholder="请输入内容" />
          <el-button class="no-border" icon="el-icon-document-copy" on-click={this.onCopyUrl}></el-button>
        </div>
        <div class="pop-container">
          <span class="r-mr-24">微页面链接</span>
          <el-input class="wid-234" v-model={this.link} disabled placeholder="请输入内容" />
          <el-button class="no-border" icon="el-icon-document-copy" on-click={this.onCopyUrlT}></el-button>
        </div>
      </div>
    ) : (
      <div class="pop-container">
        {this.siteCodeList.length > 1 && (
          <div>
            <el-input class="textInput wid-100" v-model={this.siteCode} placeholder="请输入网点编号" />
            <el-button class="scopeSpan" type="text" on-click={this.createLink}>
              生成
            </el-button>
          </div>
        )}
        <div class="r-mt-12">
          <el-input class="wid-274" v-model={this.url} disabled placeholder="请输入内容" />
          <el-button type="primary" on-click={this.onCopyUrl}>
            拷贝
          </el-button>
        </div>
        {this.remarkList.map((i) => {
          return <p class="remark">{i}</p>;
        })}
      </div>
    );
  }
}
